'use client'
import { Link as AscendLink } from '@achieve/ascend'
import { selectOverride } from './Typography'
import { INLINES } from '@contentful/rich-text-types'

export function ScrollLinkClient({
  plainText,
  identifier,
  styleOverride,
  variantOverride,
  richText,
  ...props
}) {
  const handleScrollClick = () => {
    const el = document.querySelector(`[data-scrolto="${identifier}"]`)
    if (el) {
      // Adding -70px to fix element padding
      window.scrollTo({
        top: el.offsetTop - 70,
        behavior: 'smooth',
      })
    }
  }

  return (
    <AscendLink
      sx={selectOverride(INLINES.ASSET_HYPERLINK, styleOverride, 'sx', richText)}
      variant={selectOverride(INLINES.ASSET_HYPERLINK, variantOverride, 'variant', richText)}
      data-testid={`Scroll-to-${plainText}`}
      onClick={handleScrollClick}
      aria-label={`Scroll to ${plainText}`}
      {...props}
      component={richText[INLINES.ASSET_HYPERLINK].component}
    >
      {plainText}
    </AscendLink>
  )
}

export function ScrollToMarker({ identifier }) {
  return <span data-scrolto={identifier}></span>
}
